import {IModel, ISection} from "../../model/B2CInfo";
import './CarsItem.css'
import CarsSection, {ICarSection} from "./CarsSection";
import MobileSectionHeader from "../../MobileSectionHeader";
import React, {useState} from "react";
import SectionHeader from "../../SectionHeader";
import MobileShowMore from "../../common/MobileShowMore";

interface ICarsContainerProps {
    section: ISection
    models: Map<string, IModel>
    mobile: boolean
}

export default function CarsItem(props: ICarsContainerProps) {
    let [showAll, setShowAll] = useState(false);
    let data = (props.section.data as Array<ICarSection>)
    if (props.mobile && !showAll) {
        data = [data[0]];
    }
    let sections = data.map((car, index) => {
        return <CarsSection mobile={props.mobile} section={car} models={props.models}/>
    })

    if (props.mobile) {
        return <div className="Section_container_mobile">
            <MobileSectionHeader section={props.section}/>
            {sections}
            {!showAll && <div className="Cars_section_mobile_show_more">
                <MobileShowMore title="Посмотреть все машины" onClick={(e) => setShowAll(true)}/>
            </div>}
        </div>
    } else {
        return <div className="Cars_container">
            <SectionHeader section={props.section}/>
            {sections}
        </div>
    }
}